export const registerReadMore = function expandText() {
  const readMoreButtons = document.querySelectorAll('.read-more-button')

  readMoreButtons.forEach((button) => {
  button.addEventListener('click', () => {
    button.classList.add('active')

    const readMoreBox = button.closest('.read-more-box')
    
    if (readMoreBox) {
      readMoreBox.classList.add('active')
    }
  })
})
}